// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactSection_container__2CjBu","content":"ContactSection_content__2x3oI","form":"ContactSection_form__3Xe7K"};